import $ from 'jquery';
import { updateState } from '../../home24/helpers/custom-elements';
import rivets from 'rivets';

rivets.binders['background-image'] = function(el, value) {
  if (value) {
    if (value === 'none') {
      el.style.backgroundImage = 'none';
    } else {
      el.style.backgroundImage = "url('" + value + "')";
    }
  }
};

rivets.binders['custom-checked'] = {
  publishes: true,
  priority: 2000,
  bind: function(el) {
    rivets._.Util.bindEvent(el, 'change', this.publish);
  },
  unbind: function(el) {
    rivets._.Util.bindEvent(el, 'change', this.publish);
  },
  routine: function(el, value) {
    if (el.type === 'radio') {
      el.checked =
        (el.value != null ? el.value.toString() : 0) ===
        (value != null ? value.toString() : 0);
    } else {
      el.checked = Boolean(value);
    }

    updateState();

    return el.checked;
  }
};

rivets.binders.width = function(el, value) {
  el.style.width = value + 'px';
};

rivets.binders.left = function(el, value) {
  if (value !== undefined && value !== null && value !== '') {
    el.style.left = value + 'px';
  } else {
    el.style.left = '';
  }
};

rivets.binders.show = function(el, value) {
  var $el = $(el);

  if (value) {
    $el.removeClass('is-hidden');
  } else {
    $el.addClass('is-hidden');
  }
};

rivets.binders.hide = function(el, value) {
  var $el = $(el);

  if (value) {
    $el.addClass('is-hidden');
  } else {
    $el.removeClass('is-hidden');
  }
};

rivets.binders.addclass = function(el, value) {
  if (el.addedClass) {
    $(el).removeClass(el.addedClass);
    delete el.addedClass;
  }

  if (value) {
    $(el).addClass(value);
    el.addedClass = value;
  }
};
rivets.binders['value-soft'] = {
  publishes: true,
  priority: 3000,
  bind: function(el) {
    this.valueSoftInitialized = false;
    rivets._.Util.bindEvent(
      el,
      el.tagName === 'SELECT' ? 'change' : 'input',
      this.publish
    );
  },
  unbind: function(el) {
    rivets._.Util.unBindEvent(
      el,
      el.tagName === 'SELECT' ? 'change' : 'input',
      this.publish
    );
  },
  routine: function(el, value) {
    if (el.value && !this.valueSoftInitialized) {
      this.valueSoftInitialized = true;
      rivets.binders.value.routine(el, el.value);
    } else {
      rivets.binders.value.routine(el, value);
    }
  }
};
rivets.binders['checked-soft'] = {
  publishes: true,
  priority: 3001,
  bind: function(el) {
    rivets._.Util.bindEvent(el, 'change', this.publish);
  },
  unbind: function(el) {
    rivets._.Util.unBindEvent(el, 'change', this.publish);
  },
  routine: function(el, value) {
    if (el.checked && !el.checkedSoftInitialized) {
      var self = this;
      var binders = self.view.select(function(b) {
        return b.keypath === self.keypath;
      });

      $.each(binders, function(i) {
        binders[i].el.checkedSoftInitialized = true;
      });

      this.publish();
      rivets.binders['custom-checked'].routine(el, el.value);
    } else {
      rivets.binders['custom-checked'].routine(el, value);
    }
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/rivets/binders.js
 **/